import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Search from "@insite/mobius/Icons/Search";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setSearchQuery from "@tJohnstonCompanies/Handlers/CategoryListingSearch/SetSearchQuery";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    customState: state,
});

const mapDispatchToProps = {
    setSearchQuery,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CategoryListSearchWithinStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    searchTextField?: TextFieldPresentationProps;
}

export const searchWithinStyles: CategoryListSearchWithinStyles = {
    titleText: {
        variant: "h6",
    },
    searchTextField: {
        iconProps: {
            src: Search,
            css: css`
                position: absolute;
                box-sizing: border-box;
                top: 2px;
                right: 2px;
                width: 36px;
                height: 36px;
                padding: 8px;
                border-radius: 100%;
                pointer-events: none;
                > svg {
                    stroke: #888888;
                }
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            inputSelect: css`
                border: 0px;
                border-bottom: 2px solid #cccccc;
                border-radius: 0;
                &:focus {
                    border: 0px;
                }
            `,
        },
    },
};

const styles = searchWithinStyles;

const CategoryListSearchWithin = ({ setSearchQuery }: Props) => {
    const [searchText, setSearchText] = useState("");
    const doSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (searchText.trim() !== "") {
            setSearchQuery({ searchQuery: event.currentTarget.value });
            setSearchText(event.currentTarget.value);
        } else {
            setSearchQuery({ searchQuery: event.currentTarget.value });
            setSearchText(event.currentTarget.value);
        }
    };
    return (
        <StyledWrapper {...styles.wrapper}>
            <TextField
                {...styles.searchTextField}
                value={searchText}
                onChange={event => setSearchText(event.currentTarget.value)}
                onKeyUp={doSearch}
                placeholder={translate("Search Within")}
                type="text"
                data-test-selector="CategoryListSearchWithin"
                id="categoriesKeywordSearch"
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CategoryListSearchWithin),
    definition: {
        group: "Basic",
        displayName: "Category List Search Within",
    },
};

export default widgetModule;
